import { render } from "./PanelRightDRC.vue?vue&type=template&id=2bdce20e&scoped=true&ts=true"
import script from "./PanelRightDRC.vue?vue&type=script&lang=ts"
export * from "./PanelRightDRC.vue?vue&type=script&lang=ts"

import "./PanelRightDRC.vue?vue&type=style&index=0&id=2bdce20e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdce20e"]])

export default __exports__